/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Movement } from "../../../../gen/planner/movement";

export const protobufPackage = "skills";

export interface SetMovementCommandActionArgs {
  movementCommand: Movement | undefined;
  durationS: number;
}

export interface SetMovementCommandResultData {
}

export interface SetMovementCommandActionStateData {
}

function createBaseSetMovementCommandActionArgs(): SetMovementCommandActionArgs {
  return { movementCommand: undefined, durationS: 0 };
}

export const SetMovementCommandActionArgs = {
  encode(message: SetMovementCommandActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.movementCommand !== undefined) {
      Movement.encode(message.movementCommand, writer.uint32(10).fork()).ldelim();
    }
    if (message.durationS !== 0) {
      writer.uint32(21).float(message.durationS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetMovementCommandActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMovementCommandActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.movementCommand = Movement.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.durationS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMovementCommandActionArgs {
    return {
      movementCommand: isSet(object.movementCommand) ? Movement.fromJSON(object.movementCommand) : undefined,
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
    };
  },

  toJSON(message: SetMovementCommandActionArgs): unknown {
    const obj: any = {};
    if (message.movementCommand !== undefined) {
      obj.movementCommand = Movement.toJSON(message.movementCommand);
    }
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMovementCommandActionArgs>, I>>(base?: I): SetMovementCommandActionArgs {
    return SetMovementCommandActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMovementCommandActionArgs>, I>>(object: I): SetMovementCommandActionArgs {
    const message = createBaseSetMovementCommandActionArgs();
    message.movementCommand = (object.movementCommand !== undefined && object.movementCommand !== null)
      ? Movement.fromPartial(object.movementCommand)
      : undefined;
    message.durationS = object.durationS ?? 0;
    return message;
  },
};

function createBaseSetMovementCommandResultData(): SetMovementCommandResultData {
  return {};
}

export const SetMovementCommandResultData = {
  encode(_: SetMovementCommandResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetMovementCommandResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMovementCommandResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetMovementCommandResultData {
    return {};
  },

  toJSON(_: SetMovementCommandResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMovementCommandResultData>, I>>(base?: I): SetMovementCommandResultData {
    return SetMovementCommandResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMovementCommandResultData>, I>>(_: I): SetMovementCommandResultData {
    const message = createBaseSetMovementCommandResultData();
    return message;
  },
};

function createBaseSetMovementCommandActionStateData(): SetMovementCommandActionStateData {
  return {};
}

export const SetMovementCommandActionStateData = {
  encode(_: SetMovementCommandActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetMovementCommandActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMovementCommandActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetMovementCommandActionStateData {
    return {};
  },

  toJSON(_: SetMovementCommandActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMovementCommandActionStateData>, I>>(
    base?: I,
  ): SetMovementCommandActionStateData {
    return SetMovementCommandActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMovementCommandActionStateData>, I>>(
    _: I,
  ): SetMovementCommandActionStateData {
    const message = createBaseSetMovementCommandActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
